// EditAdsModal.js
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Modal from './Modal';

const Container = styled.div`
  padding: 32px 40px;
`;

const PreviewContainer = styled.div`
  width: 100%;
  height: ${props => {
    switch(props.type) {
      case 'main': return '247px';  // 16:9
      case 'banner': return '160px';  // 2.75:1
      case 'side': return '783px';  // 9:16
      default: return '247px';
    }
  }};
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 32px;
  background-color: #f8f9fa;
  
  img, video {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const TimeInputContainer = styled.div`
  margin: 32px 0;
`;

const InputLabel = styled.label`
  display: block;
  color: #333;
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 8px;
`;

const TimeInput = styled.input`
  width: 160px;
  padding: 12px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 1.1rem;
  transition: all 0.2s;
  
  &:focus {
    outline: none;
    border-color: #4A90E2;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #eee;
`;

const Button = styled.button`
  padding: 14px 32px;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 120px;
  
  ${props => props.primary ? `
    background-color: #4A90E2;
    color: white;
    border: none;
    
    &:hover {
      background-color: #357ABD;
    }
  ` : `
    background-color: #f5f5f5;
    color: #666;
    border: 2px solid #e0e0e0;
    
    &:hover {
      background-color: #e5e5e5;
    }
  `}
`;

const EditAdsModal = ({ isOpen, onClose, ad, onConfirm }) => {
    const [duration, setDuration] = useState(5);

    useEffect(() => {
        if (isOpen && ad) {
            setDuration(ad.duration || 5);
        }
    }, [isOpen, ad]);

    const handleSubmit = () => {
        if (!duration || duration === 0) {
            alert('광고 시간을 설정하세요.');
            return;
        }
        onConfirm(ad.adsId, duration);
    };

    if (!ad) return null;

    const getMediaUrl = (url) => {
        return `https://kr.object.ncloudstorage.com/qnoss/runningtrack/ads/${url}`;
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="광고 수정"
            shouldCloseOnOverlayClick={false}
        >
            <Container>
                <PreviewContainer type={ad.type}>
                    {ad.fileType === 'image' ? (
                        <img src={getMediaUrl(ad.url)} alt="광고" />
                    ) : (
                        <video src={getMediaUrl(ad.url)} controls />
                    )}
                </PreviewContainer>

                {
                    ad.adsType === 'main' && 
                    <TimeInputContainer>
                        <InputLabel htmlFor="duration">지속 시간</InputLabel>
                        <TimeInput
                            id="duration"
                            type="number"
                            min="1"
                            value={duration}
                            onChange={(e) => setDuration(Number(e.target.value))}
                        />
                        <span style={{ marginLeft: '8px', color: '#666' }}>초</span>
                    </TimeInputContainer>
                }

                <ButtonContainer>
                    <Button onClick={onClose}>
                        취소
                    </Button>
                    <Button primary onClick={handleSubmit}>
                        수정하기
                    </Button>
                </ButtonContainer>
            </Container>
        </Modal>
    );
};

export default EditAdsModal;